module.exports = __webpack_public_path__ + "img/Cb.82c59549.png";